import ICatalog_Item from "@models/ICatalog_Item";
import { useEffect, useMemo, useState } from "react";
import { OrderItemOption } from "./OrderItemOption/OrderItemOption";
import INewOrder_Item_Option from "@models/INewOrder_Item_Option";

type Props = {
    catalogItem: ICatalog_Item;
    selectedItemOptionsFn: (options: any) => void;
    flexDirection?: "flex-row" | "flex-column";
};

export const OrderItemOptions = (props: Props) => {
    const [orderItemOptions, setOrderItemOptions] = useState<Partial<INewOrder_Item_Option>[]>([]);

    useEffect(() => {
        // console.log("OrderItemOptions", orderItemOptions);

        props.selectedItemOptionsFn(orderItemOptions);
    }, [orderItemOptions]);

    const itemOptionsCount = useMemo(() => props.catalogItem.Options?.length || 0, [props.catalogItem.Options]);

    const selectedItemOptionsFn = (option: Partial<INewOrder_Item_Option>) => {
        const updatedOrderItemOptions = [...orderItemOptions];

        const existingOption = updatedOrderItemOptions.find((o) => o.item_option_id === option.item_option_id);

        if (existingOption) {
            existingOption.value = option.value;
        } else {
            updatedOrderItemOptions.push(option);
        }

        setOrderItemOptions(updatedOrderItemOptions);
    };

    return (
        <div className={"OrderItemOptions"}>
            {itemOptionsCount > 2 ? (
                <div>{/* Show Modal */}</div>
            ) : (
                <div className={`d-flex gap-2 ${props.flexDirection || "flex-row "}`}>
                    {props.catalogItem.Options?.map((option) => (
                        <OrderItemOption key={option.Item_Option?.id} option={option} selectedItemOptionFn={selectedItemOptionsFn} />
                    ))}
                </div>
            )}
        </div>
    );
};
